import { render, staticRenderFns } from "./PasswordSendInstructions.vue?vue&type=template&id=11feb025&scoped=true&"
import script from "./PasswordSendInstructions.vue?vue&type=script&lang=ts&"
export * from "./PasswordSendInstructions.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordSendInstructions.vue?vue&type=style&index=0&id=11feb025&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11feb025",
  null
  
)

export default component.exports